import { Question } from "./QuestionTypes"

export const questions: Question[][] = [
	[
		{
			challenge: "Which metropolitan area declined in population between 1950 and 2000?",
			category: "world",
			choices: [
				{ option: "Detroit", reveal: "2.8m to 3.9m", data: 3.9 / 2.8 },
				{ option: "London", correct: true, reveal: "8.4m to 7.3m", data: 7.3 / 8.4 },
				{ option: "Moscow", reveal: "5.4m to 10.0m", data: 10.0 / 5.4 },
				{ option: "São Paulo", reveal: "2.3m to 17.0m", data: 17 / 2.3 },
			],
			citation: "https://www.macrotrends.net/cities/22974/detroit/population",
			// citation: "https://population.un.org/wpp/"
		},
		// {
		// 	challenge: "How many languages are featured on Indian banknotes?",
		// 	choices: [{ option: "4" }, { option: "7" }, { option: "12" }, { option: "17", correct: true }],
		// 	category: "world",
		// 	reveal: "indian-rupee.jpg",
		// },
		{
			challenge: "Name something you bring to bed after you've been dumped",
			choices: [
				{ option: "Food/ice cream", correct: true, data: 38 },
				{ option: "My dog/pet", data: 15 },
				{ option: "Teddy bear", data: 11 },
				{ option: "Wine/booze", data: 10 },
			],
			category: "world",
			citation: "https://mstiescott.neocities.org/feud16_8.html",
		},
		{
			challenge: "Where do guinea pigs get their name?",
			choices: [
				{ option: "Europeans first encountered them in Guinea" },
				{ option: "They are a delicacy in Guinea" },
				{ option: "They are worshipped in Guinea" },
				{ option: "Unclear", correct: true },
			],
			content: "guinea-pig.jpg",
			category: "life",
		},
		{
			challenge: "Which is the most radioactive?",
			choices: [
				// { option: "Chest x-ray", data: 100 },
				{ option: "One CT scan", data: 10000, correct: true },
				{ option: "24 hours in orbit", data: 430 },
				{ option: "Smoking a pack a day for a month", data: 2000 },
				{ option: "Using a CRT monitor for a year", data: 1 },
				// { option: "Smoking a pack a day for a year", data: 24000, correct: true },
			],
			category: "health",
			citation: "https://bit.ly/RadiationChart",
		},
		{
			challenge: 'The word "arctic" comes from which phrase?',
			choices: [
				{ option: "Of the bear", correct: true },
				{ option: "Of the bird" },
				{ option: "Of the snow" },
				{ option: "Of the wind" },
			],
			category: "world",
			reveal: "ursa-major.svg",
			citation: "https://www.dictionary.com/browse/arctic",
		},
		{
			challenge: "What isn't a Microsoft brand?",
			choices: [
				{ option: "Azure" },
				{ option: "OneDrive" },
				{ option: "Slack", correct: true },
				{ option: "Teams" },
			],
			category: "tech",
			reveal: "slack.png",
		},
		{
			challenge: "Which has the most calories?",
			choices: [
				{ option: "A gala apple (154g)", data: 80 },
				{ option: 'A head of iceburg lettuce (6", 539g)', data: 75 },
				{ option: "A slice of bacon (cooked, 8g)", data: 43 },
				{ option: "One tablespoon of canola oil (14g)", data: 120, correct: true },
			],
			category: "health",
			citation: "https://fdc.nal.usda.gov",
		},
		{
			challenge: "What feature existed on the original iPhone?",
			category: "tech",
			choices: [
				{ option: "3G cellular connectivity" },
				{ option: "Exchange email sync" },
				{ option: "Third-party app store" },
				{ option: "Visual voicemail", correct: true },
			],
			reveal: "iphone-voicemail.mp4",
			citation: "https://www.youtube.com/watch?v=_X5xOI_qu9I",
		},
		{
			challenge: "What is the elevation at the Northwest Regional Airport (YXT)?",
			citation: "https://www.airportdata.com/search-data/airport-details/icao/cyxt",
			content: "yxt.jpg",
			category: "local",
			choices: [
				{ option: "223 ft / 68 m" },
				{ option: "417 ft / 127 m" },
				{ option: "713 ft / 217 m", correct: true },
				{ option: "958 ft / 292 m" },
			],
		},
		{
			challenge: "Which is NOT true of India?",
			choices: [
				{ option: "India is composed of 146 state governments", correct: true },
				{ option: "India is forecast to be the most populous country by 2027" },
				{ option: "Cinemas have been mandated to play the national anthem before viewings" },
				{ option: "Rupee banknotes feature 17 distinct languages" },
			],
			category: "world",
		},
		{
			challenge: "Easter Island is named as such because it...",
			choices: [
				{ option: "Was discovered by captain Jaques Easter" },
				{ option: "Was discovered on Easter Sunday", correct: true },
				{ option: "Was over 300 km east of its originally reported location" },
				{ option: "Unclear" },
			],
			category: "world",
			content: "easter-island2.jpg",
			citation: "https://en.wikipedia.org/wiki/Easter_Island",
		},
		{
			challenge: '"Carotenoid" is defined as...',
			choices: [
				{ option: "1/100 of a carat" },
				{ option: "A family of yellow-red organic pigments", correct: true },
				{ option: "A genus of flowering root vegetibles" },
				{ option: "A piece of shrapnel deflected from its original trajectory" },
			],
			category: "literature",
			citation: "https://en.wikipedia.org/wiki/Carotenoid",
		},
		{
			challenge: "Which African country has the largest GDP?",
			choices: [
				{ option: "Algeria", data: 151_460_000_000 },
				{ option: "Egypt", data: 394_280_000_000 },
				{ option: "Nigeria", data: 514_050_000_000, correct: true },
				{ option: "South Africa", data: 329_530_000_000 },
			],
			category: "economics",
			citation: "https://www.statista.com/statistics/1120999/gdp-of-african-countries-by-country/",
		},
		{
			challenge: "Which is NOT true of blood types?",
			category: "health",
			// answer: "Antigen (Rhesus D)",
			choices: [
				{ option: '"+" blood types are more common' },
				{ option: "A/B/O denotes the presence of certain antigens" },
				{ option: "+/- denotes the presence of certain antigens" },
				// { option: 'AB+ people are referred to as "universal recipients"' },
				// { option: "Blood groups concern red blood cells, not blood plasma", correct: true },
				// { option: "Blood groups affect whole blood transfusions, but not plasma", correct: true },
				{ option: "Blood types concern RBCs, not plasma", correct: true },
				// { option: "AB blood has the antibodies commmon to A and to B", correct: true },
			],
			reveal: "plasma-compatibility.svg",
			citation: "https://en.wikipedia.org/wiki/Blood_type#Blood_group_systems",
		},
		{
			challenge: "What is NOT a chart type available in Microsoft Excel",
			choices: [
				{ option: "Burndown", correct: true },
				{ option: "Radar" },
				{ option: "Sunburst" },
				{ option: "Treemap" },
			],
			category: "tech",
			reveal: "insert-chart.png",
		},
		{
			challenge: "According to WorkSafeBC, what percentage of 2001-2020 workplace fatalities were men?",
			choices: [{ option: "37%" }, { option: "62%" }, { option: "80%" }, { option: "95%", correct: true }],
			reveal: "worksafe.png",
			category: "health",
		},
		{
			challenge: 'In what year was "Benjamin" the most popular boy\'s name in British Columbia?',
			choices: [
				{ option: "1920", data: 5, reveal: "110th" },
				{ option: "1986", data: 148, reveal: "35th" },
				{ option: "2000", data: 211, reveal: "8th" },
				{ option: "2017", correct: true, data: 222 },
				// { option: "1920", data: 110 },
				// { option: "1986", data: 35 },
				// { option: "2000", data: 8 },
				// { option: "2017", correct: true, data: 1 },
			],
			suffix: "that year",
			category: "local",
		},
		{
			challenge: "What is a sepulcher?",
			choices: [
				{ option: "A grave or tomb", correct: true },
				{ option: "A protruding animal habitat, eg. an anthill or burrow" },
				{ option: "A staff featuring a prominent gemstone end-cap" },
				{ option: "A tool for astronomical navigation" },
			],
			citation: "https://www.dictionary.com/browse/sepulcher",
			category: "literature",
			reveal: "tomb.jpg",
		},
		{
			challenge: '"Manifest Destiny" is the belief of',
			choices: [
				{ option: "America's duty to expand its influence", correct: true },
				{ option: "Astrological influences over our lives" },
				{ option: "Free will being illusory" },
				{ option: "The focus of your thoughts and attention being assured" },
			],
			reveal: "american-progress.jpg",
			category: "world",
			citation: "https://en.wikipedia.org/wiki/Manifest_destiny",
		},
		{
			challenge: "What movie came first?",
			category: "film",
			choices: [
				// { option: "Bambi", data: 2021 - 1942, reveal: "1942" },
				{ option: "Cinderella", data: 2021 - 1950, reveal: "1950" },
				// { option: "Dumbo", data: 2021 - 1941, reveal: "1941" },
				{ option: "Pinocchio", data: 2021 - 1940, reveal: "1940" },
				{ option: "Sleeping Beauty", data: 2021 - 1959, reveal: "1959" },
				{ option: "Snow White", correct: true, data: 2021 - 1937, reveal: "1937" },
			],
			suffix: "years ago",
		},
	],
	[
		{
			challenge: "Which ocean is the deepest?",
			answer: "Pacific",
			// choices: [
			// 	{ option: "Arctic", data: 5550 },
			// 	{ option: "Atlantic", data: 8376 },
			// 	{ option: "Indian", data: 7258 },
			// 	{ option: "Pacific", correct: true, data: 10984 },
			// ],
			// reveal: "mariana-trench.png",
			reveal: "ocean-depth.png",
			category: "world",
			citation: "https://en.wikipedia.org/wiki/Mariana_Trench",
			suffix: "m",
		},
		{
			challenge: "What is the name for this muscle?",
			content: "gastrocnemius.gif",
			answer: "Gastrocnemius",
			category: "health",
			citation: "https://en.wikipedia.org/wiki/Gastrocnemius_muscle",
		},
		{
			challenge:
				"How long are the dashes on a broken dashed yellow passing lane on a rural BC highway, to the nearest metre?",
			citation:
				"https://www2.gov.bc.ca/assets/gov/driving-and-transportation/transportation-infrastructure/engineering-standards-and-guidelines/traffic-engineering-and-safety/traffic-engineering/traffic-signs-and-pavement-markings/manual_signs_pavement_marking.pdf",
			category: "industry",
			answer: 5,
			reveal: "line-markings.png",
		},
		{
			challenge: "What is the largest aisle number at the Terrace Save-On-Foods?",
			answer: 14,
			category: "local",
			reveal: "saveon.jpg",
		},
		{
			challenge: "Name a country that touches the Caucasus Mountains",
			category: "world",
			answer: "Armenia, Azerbaijan, Georgia, Iran, Russia, Turkey",
			content: "caucasus-mountains.jpg",
			reveal: "caucasus-mountains.svg",
		},
		{
			category: "world",
			// Eu-wan, Ming, Ching
			challenge: "Order these Chinese dynasties which spanned from 1271 to 1912: Ming, Qing, Yuan",
			citation: "https://en.wikipedia.org/wiki/Dynasties_in_Chinese_history",
			answer: "Yuan, Ming, Qing",
		},
		{
			challenge: "What is the 50th percentile for height of a 10yo girl in Canada, ±1yr?",
			answer: "133/139/145 cm",
			// choices: [
			// 	{ option: "138 cm / 54 in", correct: true, data: 10 },
			// 	{ option: "144 cm / 57 in", data: 11 },
			// 	{ option: "151 cm / 60 in", data: 12 },
			// 	{ option: "157 cm / 62 in", data: 13 },
			// ],
			// citation: "https://www.cdc.gov/growthcharts/charts.htm",
			citation: "https://www.dietitians.ca/Secondary-Pages/Public/Who-Growth-Charts.aspx",
			category: "health",
			reveal: "girl-height.png",
		},
		{
			challenge: "What is the greatest number of statements that can be true without contradiction?",
			content: "contradictions.png",
			answer: "0 - contradictions are unavoidable (Sorry!)",
			category: "puzzle",
		},
		{
			challenge: "How many continents does WestJet fly to?",
			answer: "4",
			category: "world",
			reveal: "westjet-flights.png",
		},
		{
			challenge: "How long was the Titanic +/- 100 ft?",
			category: "industry",
			answer: "883 ft / 269 m",
			content: "titanic.jpg",
			reveal: "ship-size.jpg",
		},
		{
			challenge: "Name any year within the period of the Hundred Years War",
			answer: "1337 - 1453",
			category: "world",
			citation: "https://en.wikipedia.org/wiki/Hundred_Years%27_War",
			reveal: "agincourt.jpg",
		},
		{
			// challenge: "What event is this, and where?",
			// answer: ["Expo 2020", "Dubai, UAE"],
			challenge: "What event is this?",
			answer: "Expo 2020",
			content: "expo-2020.mp4",
			fullscreen: true,
			reveal: "expo-2020-answer.mp4",
			category: "world",
		},
		// {
		// 	category: "puzzle",
		// 	challenge: "4a + 5b = 2c, 2a + 3b = c, a = ?",
		// 	answer: "2a = c - 3b, a = 4(c-3b)/2, 2c-12b+4b=2c",
		// },
		{
			challenge: "How many degrees is the blue angle?",
			category: "puzzle",
			answer: 110,
			reveal: "puzzle-degrees.mp4",
			content: "angles.jpg",
			citation: "https://www.instagram.com/p/CHiptwvHwEM/",
		},
		{
			challenge: "Who is depicted in this painting?",
			category: "art",
			content: "princess-elizabeth.jpg",
			answer: "Princess (now Queen) Elizabeth",
		},
		{
			challenge: "What city is this?",
			content: "seoul.jpg",
			category: "world",
			citation: "https://www.lwt.co.kr/en/main/main.do",
			reveal: "seoul-map.png",
			answer: "Seoul (and the Lotte World Tower)",
		},
		{
			challenge: "In what decade was the Empire State Building completed?",
			answer: 1931,
			content: "empire-state-building.jpg",
			category: "industry",
		},
		{ challenge: "Solve the rebus", category: "puzzle", content: "green-nv.png", answer: "Green with envy" },
		{
			challenge: 'What is the plural of "chassis"?',
			category: "literature",
			citation: "https://www.dictionary.com/browse/chassis",
			answer: "Chassis",
		},
		{
			challenge: "What country is this?",
			category: "world",
			content: "bolivia.svg",
			reveal: "bolivia-flag.svg",
			answer: "Bolivia",
		},

		{
			category: "world",
			challenge: "Spell the name of the company Meng Wanzhou (孟晚舟) is the CFO of",
			content: "meng-wanzhou.jpg",
			reveal: "huawei.svg",
			answer: "Huawei",
		},
	],
	[
		{
			challenge: "Name the actress",
			category: "film",
			content: "cruella.mp4",
			answer: "Emma Stone (in Cruella)",
			reveal: "cruella.jpg",
			fullscreen: true,
		},
		{
			challenge: "What year was this song released, ±2 yrs?",
			content: "otherside.mp4",
			answer: "2000 (Red Hot Chili Peppers - Otherside)",
			category: "music",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "down-periscope.mp4",
			answer: "Down Periscope",
			reveal: "down-periscope.jpg",
			fullscreen: true,
		},
		{
			challenge: "Name the actor",
			category: "film",
			content: "stellan-skarsgard.mp4",
			reveal: "stellan-skarsgard.jpg",
			fullscreen: true,
			answer: "Stellan Skarsgård",
		},
		{
			challenge: "What TV show is this?",
			answer: "Chernobyl",
			content: "chernobyl.mp4",
			reveal: "chernobyl.jpg",
			category: "film",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "das-boot.mp4",
			answer: "Das Boot",
			reveal: "das-boot.jpg",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "coco.mp4",
			answer: "Coco",
			reveal: "coco.jpg",
			fullscreen: true,
		},
		{
			challenge: "What song is this?",
			content: "lola.mp4",
			answer: "Lola (The Kinks)",
			category: "music",
			reveal: "the-kinks.jpg",
			fullscreen: true,
		},
		{
			challenge: "Name this TV show",
			category: "film",
			content: "murdoch-mysteries.mp4",
			answer: "Murdoch Mysteries",
			reveal: "murdoch-mysteries.jpg",
			fullscreen: true,
		},
		{
			challenge: "What video game franchise is this?",
			answer: "Gears of War (3)",
			category: "games",
			content: "gears-of-war.mp4",
			reveal: "gears-of-war.jpg",
			fullscreen: true,
		},
		{
			challenge: "Who composed this?",
			answer: "Frederic Chopin",
			reveal: "chopin.jpg",
			content: "funeral-march.mp4",
			category: "music",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "greatest-showman.mp4",
			reveal: "greatest-showman.jpg",
			answer: "The Greatest Showman",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "ad-astra.mp4",
			reveal: "ad-astra.jpg",
			answer: "Ad Astra",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "galaxy-quest.mp4",
			reveal: "galaxy-quest.jpg",
			answer: "Galaxy Quest",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			category: "film",
			content: "the-grey.mp4",
			reveal: "the-grey.jpg",
			answer: "The Grey",
			fullscreen: true,
		},
		{
			challenge: "What year was this song released, ±1 yr? ",
			content: "moves-like-jagger.mp4",
			answer: "2011",
			category: "music",
			citation: "https://en.wikipedia.org/wiki/Moves_like_Jagger",
			fullscreen: true,
		},
		{
			challenge: "What upcoming movie is this trailer for?",
			answer: "Lightyear",
			content: "lightyear.mp4",
			reveal: "lightyear.jpg",
			category: "film",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			content: "chicago.mp4",
			answer: "Chicago",
			category: "film",
			fullscreen: true,
		},
		{
			challenge: "Who is the artist?",
			content: "what-you-waiting-for2.mp4",
			answer: "Gwen Stefani",
			category: "music",
			fullscreen: true,
		},
		{
			challenge: "Name the movie AND the original book author",
			category: "film",
			content: "time-machine.mp4",
			reveal: "time-machine-wells.jpg",
			answer: ["The Time Machine", "H. G. Wells"],
			fullscreen: true,
		},
	],
]
